import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Button, Input, Pagination, SelectPicker, Tag } from "rsuite";
import { createAPIEndpoint } from "../../API/authenticated.request";
import Grid from "../../Components/Grid";
import Responsive from "../../Components/Responsive";
import { Base_URL2 } from "../../Config/api.config";
import { minHeight, width } from "@mui/system";
import moment from "moment";
import Filter from "../../Components/Common/Filter";
import Swal from "sweetalert2";

const SendMessages = () => {
  //-------- States  --------//
  const [filterModel, setfilterModel] = useState({
    q: "",
    disponibilityId: 0,
    page: 1,
    take: 20000,
  });
  const [messages, setmessages] = useState({
    msg1: "",
    msg2: "",
    msg3: "",
    msg4: "",
  });
  const [selectedMessageType, setselectedMessageType] = useState(0);
  const [selectedMessage, setselectedMessage] = useState("");
  const [dates, setdates] = useState([]);
  const [dataCustomers, setdataCustomers] = useState([]);
  const [totalCount, settotalCount] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumbers, setPhoneNumbers] = useState([]);

  //-------- Variables --------//
  const columns = [
    {
      value: "customer",
      render: (v) => {
        return (
          <p
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {
              <img
                src={Base_URL2 + "Uploads/CustomerPictures/" + v.picture}
                height={35}
                width={35}
                style={{
                  borderRadius: "50%",
                  overflow: "hidden",
                }}
              />
            }
          </p>
        );
      },
    },
    {
      name: "Nom",
      value: "customer",
      render: (v) => {
        return <p style={{ fontSize: 17 }}>{v.name}</p>;
      },
    },
    {
      name: "CIN",
      value: "customer",
      render: (v) => {
        return <p style={{ fontSize: 17 }}>{v.cin}</p>;
      },
    },
    {
      name: "Date",
      value: "disponibility",
      render: (v) => {
        return <p style={{ fontSize: 17 }}>{v ? v.date.slice(0, 10) : ""}</p>;
      },
    },

    {
      name: "Téléphone",
      value: "customer",
      render: (v) => {
        return (
          <p style={{ color: "green", fontSize: 17 }}>
            {v.phoneNumber ? v.phoneNumber : "--"}
          </p>
        );
      },
    },
  ];
  const data = [
    { label: "Avant le depart", value: 1 },
    { label: "Après retour", value: 2 },
  ];

  //-------- Functions --------//
  const messageSelection = () => {
    if (selectedMessageType == 1) {
      setselectedMessage(messages.msg2);
    } else if (selectedMessageType == 2) {
      setselectedMessage(messages.msg3);
    } else setselectedMessage("");
  };
  const getMessages = () => {
    createAPIEndpoint("Message", filterModel)
      .fetch()
      .then((res) => setmessages(res.data.data[0]))
      .catch((err) => console.log(err));
  };
  const getDates = () => {
    createAPIEndpoint("PackageUmrah/getDates", { q: "" })
      .fetch()
      .then((res) => {
        let filteredDates = res.data.data.filter((date) =>
          filterModel.seasonId ? date.seasonId == filterModel.seasonId : date
        );
        setdates(
          filteredDates
            .reduce(
              (accumulator, el) => accumulator.concat(el.disponibilities),
              []
            )
            .map((el) => ({
              label: el.airline
                ? moment(el.date).format("DD/MM/YYYY") +
                  " -- " +
                  el.airline.fullName
                : "",
              value: el.id,
            }))
        );
      })
      .catch((err) => console.log(err));
  };
  const getCustomers = () => {
    createAPIEndpoint("/Order/Umrah", filterModel)
      .fetch()
      .then((res) => {
        setdataCustomers(res.data.data);
        settotalCount(res.data.totalCount);
      })
      .catch((err) => console.log(err));
  };
  const sendMessages = () => {
    createAPIEndpoint("Message/SendCommercialMessage")
      .create(phoneNumbers)
      .then((res) => console.log(res))
      .catch((err) => console.log(err));
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && phoneNumber.trim()) {
      e.preventDefault();
      const phone = phoneNumber.trim();
      if (/^\+?\d{8}$/.test(phone)) {
        setPhoneNumbers((prev) => [...prev, phone]);
        setPhoneNumber("");
      } else {
        Swal.fire({
          title: "Numero incorrect",
          icon: "error",
        });
      }
    }
  };
  const removeAtIndex = (arr, i) => {
    var list = [...arr];
    if (i >= 0 && i < arr.length) {
      list.splice(i, 1);
    }
    setPhoneNumbers(list);
  };

  const reset = () => {
    setdataCustomers([]);
  };
  useEffect(() => messageSelection(), [selectedMessageType]);

  useEffect(() => {
    getDates();
    getMessages();
  }, []);
  useEffect(() => console.log(dates), [dates]);
  return (
    <div className="p-10">
      <Responsive className="p-10" m={5} l={5} xl={5}>
        <Input
          placeholder="Ajouter un numero "
          value={phoneNumber}
          onChange={(v) => setPhoneNumber(v)}
          onKeyDown={handleKeyDown}
        />
      </Responsive>
      {/* <Responsive className="p-10" m={5} l={5} xl={5}>
        <Button onClick={handleKeyDown(phoneNumber)} appearance="primary">
          Ajouter
        </Button>
      </Responsive> */}

      <Responsive
        className="p-10"
        style={{ background: "white", minHeight: 250 }}
      >
        {phoneNumbers.map((number, index) => {
          return (
            <Tag
              style={{ background: "rgb(238, 238, 238)", height: 25 }}
              closable
              onClose={() => {
                // alert("ok");
                removeAtIndex(phoneNumbers, index);
              }}
            >
              {number}
            </Tag>
          );
        })}
      </Responsive>
      <Responsive className="p-10">
        <Button
          appearance="primary"
          style={{ float: "right", fontSize: 17 }}
          onClick={sendMessages}
        >
          Envoyer
        </Button>
      </Responsive>
    </div>
  );
};

export default SendMessages;
